module.exports = __webpack_public_path__ + "static/img/tx007.db03d39.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/qualifications/tx007.png
// module id = ACKt
// module chunks = 1